import { Selector } from '@ngxs/store';

import {
  UnsavedFiltersState,
  UnsavedFiltersStateModel,
} from '../unsaved-filters.state';

export class UnsavedFiltersSelectors {
  @Selector([UnsavedFiltersState])
  static allUnsavedFilters(
    state: UnsavedFiltersStateModel,
  ): UnsavedFiltersStateModel {
    return state;
  }

  @Selector([UnsavedFiltersState])
  static getFiltersByPage(state: UnsavedFiltersStateModel) {
    return (pageKey: string) => state[pageKey]?.filters || null;
  }

  @Selector([UnsavedFiltersState])
  static getPaginationStartIndex(state: UnsavedFiltersStateModel) {
    return (pageKey: string) => state[pageKey]?.pagination?.startIndex ?? null;
  }

  @Selector([UnsavedFiltersState])
  static getGridStateByPage(state: UnsavedFiltersStateModel) {
    return (pageKey: string) => state[pageKey] || null;
  }

  @Selector([UnsavedFiltersState])
  static hasUnsavedFilters(state: UnsavedFiltersStateModel): boolean {
    return Object.values(state).some((pageState) => !!pageState.filters);
  }

  @Selector([UnsavedFiltersState])
  static hasUnsavedFiltersForPage(state: UnsavedFiltersStateModel) {
    return (pageKey: string) => !!state[pageKey]?.filters;
  }
}
